module.exports = __webpack_public_path__ + "img/p_sz_22.73f65d47.png";